import { Fragment, useEffect, useState } from 'react';
import { GetCities, GetLocations, GetLocationsV2 } from '../../Services';
import Spinner from '../spinner/Spinner';
import './LocationsGeneratorV2.css';
import { toast } from 'react-toastify';
import GridMapV5 from '../gridReport/v5/gridMap/GridMapV5';

const LocationsGeneratorV2 = ({ location, onLocationsUpdate, onCircleMove = null, campaign = null }) => {
	const [ isEditMode, setIsEditMode ] = useState(true);
	const [ isGenerating, setIsGenerating ] = useState(false);
	const [ generatedLocations, setGeneratedLocations ] = useState();
	const [ lat, setLat ] = useState('');
	const [ lng, setLng ] = useState('');
	const [ radius, setRadius ] = useState('30');
	const [ locationsForMap, setLocationsForMap ] = useState();
	const [ locationsString, setLocationsString ] = useState();
	const [ distance, setDistance ] = useState('30');
	const [ mapPreviewGridData, setMapPreviewGridData ] = useState();
	const [ isLoadingMap, setIsLoadingMap ] = useState(false);

	useEffect(
		() => {
			if (location) {
				setLat(location.lat.toString());
				setLng(location.lng.toString());

				setMapPreviewGridData({
					googlePlaceId : campaign.googlePlaceId,
					lat           : location.lat,
					lng           : location.lng
				});
			}
		},
		[ location ]
	);

	useEffect(
		() => {
			//console.log('generatedLocations', generatedLocations);
			setIsEditMode(!generatedLocations || !generatedLocations.cities || generatedLocations.cities.length === 0);
		},
		[ generatedLocations ]
	);

	const toggleEditMode = () => {
		setIsEditMode((prev) => !prev);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (lat.trim() === '' || lng.trim() === '' || radius.trim() === '') {
			return;
		}

		setIsGenerating(true);

		let data = {
			lat                   : lat,
			lng                   : lng,
			radiusMiles           : radius,
			DistanceBetweenPoints : distance
		};

		// const response = await GetLocationsV2(data);
		const response = await GetCities(data);

		//console.log(response);

		if (response.success) {
			if (onLocationsUpdate) {
				onLocationsUpdate(response.cities);
			}
		}

		// setLocationsString(response);
		setGeneratedLocations(response.cities);

		let tempLocationsString = '';
		let tempLocationsForMap = [];

		if (response && response.cities && response.cities.length > 0) {
			response.cities.forEach((city) => {
				tempLocationsString += `${city.city}, ${city.stateName}, ${city.stateAbbr}\r\n`;

				tempLocationsForMap.push({
					...city,
					location : city.city
				});
			});
		}

		setLocationsString(tempLocationsString);
		setLocationsForMap(tempLocationsForMap);

		setIsGenerating(false);
	};

	const handleCopyToClipboard = () => {
		let copyText = document.querySelector('.clipboard');
		copyText.select();
		copyText.setSelectionRange(0, 99999);
		document.execCommand('copy');

		toast.success('Copied to clipboard!');
	};

	const handleCircleMove = (center) => {
		if (center) {
			setMapPreviewGridData({
				...mapPreviewGridData,
				lat : center.lat,
				lng : center.lng
			});

			setLat(center.lat.toString());
			setLng(center.lng.toString());

			if (onCircleMove) {
				onCircleMove(center);
			}
		}
	};

	const handleLocationMarkerRemove = (location) => {
		if (locationsForMap) {
			let tempLocationsForMap = [ ...locationsForMap ];

			tempLocationsForMap = tempLocationsForMap.filter((x) => x.lat !== location.lat);

			setLocationsForMap(tempLocationsForMap);
		}

		if (generatedLocations) {
			let tempGeneratedLocations = [ ...generatedLocations ];

			tempGeneratedLocations = tempGeneratedLocations.filter((x) => x.lat !== location.lat);

			setGeneratedLocations(tempGeneratedLocations);

			if (onLocationsUpdate) {
				onLocationsUpdate(tempGeneratedLocations);
			}
		}
	};

	return (
		<div className="locations-generator">
			<h5 className="mb-2">Locations Generator</h5>

			<div className="row location-settings">
				<form onSubmit={handleSubmit}>
					<div className="mb-2 me-2">
						<label htmlFor="latitude" className="form-label">
							Latitude:
						</label>
						<input
							type="text"
							className="form-control"
							id="latitude"
							placeholder="Latitude"
							value={lat}
							onChange={(e) => setLat(e.target.value)}
							disabled={isGenerating}
						/>
					</div>
					<div className="mb-2 me-2">
						<label htmlFor="longitude" className="form-label">
							Longitude:
						</label>
						<input
							type="text"
							className="form-control"
							id="longitude"
							placeholder="Longitude"
							value={lng}
							onChange={(e) => setLng(e.target.value)}
							disabled={isGenerating}
						/>
					</div>
					<div className="mb-2 me-2">
						<label htmlFor="radius" className="form-label">
							Radius (miles):
						</label>
						<div className="input-group">
							<input
								type="range"
								id="radius"
								name="radius"
								className="form-range"
								placeholder="Radius"
								value={radius}
								onChange={(e) => setRadius(e.target.value)}
								min={1}
								max={30}
								step={1}
								disabled={isGenerating}
							/>
							<span className="radius-value">{`${radius || ''} miles`}</span>
						</div>
					</div>
					{/* <div className="mb-3">
							<label htmlFor="radius" className="form-label">
								Distance between points (miles):
							</label>
							<input
								type="text"
								className="form-control"
								id="distance"
								placeholder="Distance between points"
								value={distance}
								onChange={(e) => setDistance(e.target.value)}
							/>
						</div> */}
					<div className="buttons-container">
						<button type="submit" className="btn btn-primary">
							<span>Generate Locations</span>
						</button>
					</div>
				</form>
			</div>

			{isGenerating && (
				<div className="locations-generator">
					<Spinner />
				</div>
			)}

			{!isGenerating && (
				<Fragment>
					<ul className="nav nav-tabs" id="tabLocationsGenerator" role="tablist">
						<li className="nav-item" role="presentation" key="map">
							<button
								className="nav-link active"
								id="map-tab"
								data-bs-toggle="tab"
								data-bs-target="#map-tab-pane"
								type="button"
								role="tab"
								aria-controls="map-tab-pane"
								aria-selected="true"
							>
								Map
							</button>
						</li>
						<li className="nav-item" role="presentation" key="locations">
							<button
								className="nav-link"
								id="locations-tab"
								data-bs-toggle="tab"
								data-bs-target="#locations-tab-pane"
								type="button"
								role="tab"
								aria-controls="locations-tab-pane"
								aria-selected="true"
							>
								Locations
							</button>
						</li>
					</ul>
					<div className="tab-content border" id="tabLocationsGeneratorContent">
						<div
							className="tab-pane fade show active"
							id="map-tab-pane"
							role="tabpanel"
							aria-labelledby="map-tab"
							tabIndex="0"
						>
							<div className="col-12 map-wrapper">
								{((location && !mapPreviewGridData) || isGenerating || isLoadingMap) && (
									<div className="loading-map">
										<Spinner />
									</div>
								)}

								{mapPreviewGridData &&
								campaign && (
									<GridMapV5
										key="map-preview"
										mapIdValue="report-map-preview"
										gridData={mapPreviewGridData}
										placeId={campaign.googlePlaceId}
										showCircle={true}
										showCenterMarker={false}
										circleRadius={radius}
										onCircleMove={handleCircleMove}
										moveCircle={true}
										isPreview={true}
										locations={locationsForMap}
										removeLocationMarker={true}
										onLocationMarkerRemove={handleLocationMarkerRemove}
									/>
								)}
							</div>
						</div>
						<div
							className="tab-pane fade p-3"
							id="locations-tab-pane"
							role="tabpanel"
							aria-labelledby="locations-tab"
							tabIndex="0"
						>
							{generatedLocations &&
							generatedLocations.length > 0 && (
								<Fragment>
									<div className="results-container">
										<button
											type="button"
											className="btn btn-outline-primary"
											onClick={handleCopyToClipboard}
										>
											<span>Copy to Clipboard</span>
										</button>

										<div className="count text-muted">
											<span>Count: {generatedLocations.length}</span>
										</div>
									</div>
									<table className="table">
										<thead>
											<tr>
												<th scope="col">#</th>
												<th scope="col">Name</th>
												<th scope="col">State</th>
												<th scope="col">State Abbr.</th>
											</tr>
										</thead>
										<tbody>
											{generatedLocations.map((generatedLocation, index) => (
												<tr key={index}>
													<th scope="row">{index + 1}</th>
													<td>{generatedLocation.city}</td>
													<td>{generatedLocation.stateName}</td>
													<td>{generatedLocation.stateAbbr}</td>
												</tr>
											))}
										</tbody>
									</table>

									<textarea className="clipboard" value={locationsString} readOnly />
								</Fragment>
							)}
						</div>
					</div>
				</Fragment>
			)}
		</div>
	);
};

export default LocationsGeneratorV2;
